import { render, staticRenderFns } from "./build_health_home_dashboard.vue?vue&type=template&id=08a528ea&scoped=true"
import script from "./build_health_home_dashboard.vue?vue&type=script&lang=js"
export * from "./build_health_home_dashboard.vue?vue&type=script&lang=js"
import style0 from "./build_health_home_dashboard.vue?vue&type=style&index=0&id=08a528ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a528ea",
  null
  
)

export default component.exports